import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeading } from '../components/PageHeading';
import { business } from '../data/site';
import { smsProgram } from '../data/smsProgram';
import { usePageMeta } from '../hooks/usePageMeta';
const headingClass = 'font-display text-[22px] font-bold tracking-tight text-ink';
const linkClass = 'font-semibold text-brand-dark underline underline-offset-2 hover:text-ink';
export function SmsTerms() {
  usePageMeta('SMS Terms | East End Automotive Repair', 'Terms for East End Automotive Repair, LLC customer-care texts about inquiries, appointments, and repair updates.');
  return <>
      <PageHeading eyebrow="Customer-care texts" title="SMS Terms" intro="Text message terms for East End Automotive Repair Customer Care." showCall={false} data-id="element-759" data-mp="3rkshlqml3bnq" />
      <article className="mx-auto max-w-3xl space-y-9 px-5 py-12 text-[16px] leading-relaxed text-steel/85 sm:py-16 lg:px-8" data-id="element-760" data-mp="16rfeasvaltn6">
        <p className="text-[14px] text-steel/65" data-id="element-761" data-mp="16wsyc6vnrplk">
          Last updated: {smsProgram.updatedLabel}
        </p>

        <p data-id="element-762" data-mp="1bvnjhfh3lq8u">
          East End Automotive Repair Customer Care is operated by {smsProgram.legalName}.
        </p>

        <section aria-labelledby="sms-program" data-id="element-763" data-mp="1guqoizx2vwgt">
          <h2 id="sms-program" className={headingClass} data-id="element-764" data-mp="1gsvyx8av3g6e">What the program covers</h2>
          <p className="mt-3" data-id="element-765" data-mp="1kw26cj9pndeg">
            {smsProgram.name} provides text messages about your customer
            inquiries, appointments, and repair updates. This program does
            not send marketing, promotional, or financing messages.
          </p>
          <p className="mt-3" data-id="element-766" data-mp="x6rang77w976">
            Messages come from {smsProgram.sender}. This is the customer-care
            program number, separate from the shop phone and existing shop
            texting number, {business.phone}.
          </p>
        </section>

        <section aria-labelledby="sms-consent" data-id="element-767" data-mp="5e0m7rvrzosh">
          <h2 id="sms-consent" className={headingClass} data-id="element-768" data-mp="9gdhtngt66bj">Your choice to receive texts</h2>
          <p className="mt-3" data-id="element-769" data-mp="1crkip93r8dcg">
            Submitting a callback or appointment request through this website
            does not enroll you in this SMS program. These forms do not collect
            consent to receive text messages.
          </p>
          <p className="mt-3" data-id="element-770" data-mp="1mk8ec0j00b9l">
            Separate consent is required before program messages can be sent.
            Consent is not a condition of purchase or service.
          </p>
        </section>

        <section aria-labelledby="sms-frequency" data-id="element-771" data-mp="tvkrw1mijfug">
          <h2 id="sms-frequency" className={headingClass} data-id="element-772" data-mp="ovf5p0z0iljr">Frequency and charges</h2>
          <p className="mt-3" data-id="element-773" data-mp="12uobd6pldx9h">
            Message frequency varies with your inquiry, appointment, or repair.
            Message and data rates may apply according to your mobile plan.
            Carriers are not liable for delayed or undelivered messages.
          </p>
        </section>

        <section aria-labelledby="sms-stop" data-id="element-774" data-mp="2a800dvucc2o2">
          <h2 id="sms-stop" className={headingClass} data-id="element-775" data-mp="2a76qwn3zyz28">Stop messages or get help</h2>
          <p className="mt-3" data-id="element-776" data-mp="2hqg30o3w1buz">
            Reply STOP to any program message to opt out. You may receive one
            final message confirming your opt-out; no further program messages
            will be sent unless you provide new consent.
          </p>
          <p className="mt-3" data-id="element-777" data-mp="2crwfij9nbs0i">
            Reply HELP for help, call the shop at{' '}
            <a href={business.phoneHref} className={linkClass} data-id="element-778" data-mp="2ctzcjn97uleq">{business.phone}</a>,
            or email{' '}
            <a href={`mailto:${business.email}`} className={`${linkClass} break-words`} data-id="element-779" data-mp="35gtuacenf6oi">{business.email}</a>.
          </p>
        </section>

        <section aria-labelledby="sms-privacy" data-id="element-780" data-mp="2qr5vpixuqm4h">
          <h2 id="sms-privacy" className={headingClass} data-id="element-781" data-mp="2vr0mlmhmnbpj">Your privacy</h2>
          <p className="mt-3" data-id="element-782" data-mp="2vp7fk633qph0">
            Read our{' '}
            <Link to={smsProgram.privacyPath} className={linkClass} data-id="element-783" data-mp="3jgcrwb9u2zmk">Privacy Policy</Link>{' '}
            for how we handle mobile information and SMS consent.
          </p>
        </section>

        <Link to={smsProgram.contactPath} className={linkClass} data-id="element-784" data-mp="20jj8c60nzrfg">
          Contact The East End Team
        </Link>
      </article>
    </>;
}